import {Injectable} from '@angular/core';
import {AppConstants} from '../app-constants';
import {UserDetailsModel} from '../../modules/auth/models/user-details-model';

@Injectable()
export class LocalStorageService {

    private static readonly APP_PORTAL_SECURITY_TOKEN_KEY = 'appPortalSecurityToken';
    private static readonly DEALER_PORTAL_SECURITY_TOKEN_KEY = 'dealerPortalSecurityToken';

    private static readonly ACCESS_TOKEN_KEY = 'accessToken';
    private static readonly REFRESH_TOKEN_KEY = 'refreshToken';
    private static readonly AUTH_ERROR_TYPE_KEY = 'authError';

    private static readonly PROJECT_FILTER_KEY = 'projectFilter';
    private static readonly USER_DETAILS_KEY = 'userDetails';


    setItem(key: string, value: string) {
        localStorage.setItem(AppConstants.LOCAL_STORAGE_PREFIX + key, value);
    }
    getItem(key: string): string | null {
        return localStorage.getItem(AppConstants.LOCAL_STORAGE_PREFIX + key);
    }
    removeItem(key: string) {
        localStorage.removeItem(AppConstants.LOCAL_STORAGE_PREFIX + key);
    }


    removeAppPortalSecurityToken(): void {
        this.removeItem(LocalStorageService.APP_PORTAL_SECURITY_TOKEN_KEY);
    }


    getAppPortalSecurityToken(): string {
        return this.getItem(LocalStorageService.APP_PORTAL_SECURITY_TOKEN_KEY);
    }


    removeDealerPortalSecurityToken(): void {
        this.removeItem(LocalStorageService.DEALER_PORTAL_SECURITY_TOKEN_KEY);
    }



    getDealerPortalSecurityToken(): string {
        return this.getItem(LocalStorageService.DEALER_PORTAL_SECURITY_TOKEN_KEY);
    }

    saveAuthTokens(accessToken: string, refreshToken: string) {
        this.setItem(LocalStorageService.ACCESS_TOKEN_KEY, accessToken);
        this.setItem(LocalStorageService.REFRESH_TOKEN_KEY, refreshToken);
        this.removeAuthErrorType();
    }

    getAccessToken(): string | null {
        return this.getItem(LocalStorageService.ACCESS_TOKEN_KEY);
    }

    getRefreshToken(): string | null {
        return this.getItem(LocalStorageService.REFRESH_TOKEN_KEY);
    }

    saveAuthErrorType(error: any) {
        this.setItem(LocalStorageService.AUTH_ERROR_TYPE_KEY, JSON.stringify(error));
    }

    getAuthErrorType(): any {
        const error = this.getItem(LocalStorageService.AUTH_ERROR_TYPE_KEY);
        return error ? JSON.parse(error) : null;
    }

    removeAuthErrorType() {
        this.removeItem(LocalStorageService.AUTH_ERROR_TYPE_KEY);
    }

    removeAuthTokens() {
        this.removeItem(LocalStorageService.ACCESS_TOKEN_KEY);
        this.removeItem(LocalStorageService.REFRESH_TOKEN_KEY);
    }

    saveProjectFilter(filter: string) {
        this.setItem(LocalStorageService.PROJECT_FILTER_KEY, filter);
    }
    getProjectFilter(): string | null {
        return this.getItem(LocalStorageService.PROJECT_FILTER_KEY);
    }
    removeProjectFilter() {
        this.removeItem(LocalStorageService.PROJECT_FILTER_KEY);
    }

    saveUserDetails(userDetails: UserDetailsModel) {
        this.setItem(LocalStorageService.USER_DETAILS_KEY, JSON.stringify(userDetails));
    }

    getUserDetails(): UserDetailsModel {
        const userDetails = this.getItem(LocalStorageService.USER_DETAILS_KEY);
        return userDetails ? JSON.parse(userDetails) : null;
    }

    removeUserDetails() {
        this.removeItem(LocalStorageService.USER_DETAILS_KEY);
    }


}
